import request from '@/utils/request'


/**
 * 根据工号获取绑定虚拟号次数
 * @param {Object} empNo
 */
export function getVirtualNumberBindCount(empNo) {
    return request({
        url: `/api/BindVirtualNumber/getVirtualNumberBindCount?EmpNo=${empNo}`,
        method: 'get',
    })
}

/**
 * 是否开通虚拟号
 * @param {Object} empNo
 */
export function flagExist(empNo) {
    return request({
        url: `/api/BindVirtualNumber/flagExist?EmpNo=${empNo}`,
        method: 'get',
    })
}

/**
 * 保存绑定虚拟号
 * @param {Object} data
 */
export function SaveVirtualNumber(data) {
    return request({
        url: `/api/BindVirtualNumber/SaveVirtualNumber`,
        method: 'post',
		data: data
    })
}


/**
 * 保存绑定虚拟号
 * @param {Object} data
 */
export function CheckedVirtualNumber(empNo) {
    return request({
        url: `/api/BindVirtualNumber/CheckedVirtualNumber?empNo=${empNo}`,
        method: 'get',
    })
}